import React from 'react'
import { withFirebase } from './components/Firebase';
import logo from './TrueNorth.png';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CustomNavbar from './components/CustomNavBar'
const axios = require('axios');


class Activate extends React.Component {
  render() {
    return( 
    <div style={{height:'100%'}}>
       <SignUpForm />
    </div>
    )
  }
}

let INITIAL_STATE = {};

  
  class SignUpFormBase extends React.Component {
    constructor(props) {
      super(props);

      //USD,EUR,GBP
      this.moneyConvert(2500,'GBP', 'EUR', 'USD');

      INITIAL_STATE = {
        boatname: '',
        email: '',
        error: null,
        id: this.id(),
        ZAR: 2500,
        GBP: '',
        EUR: '',
        USD: ''
      };
      
      this.state = { ...INITIAL_STATE };

      

    }
  
    onSubmit = () => {
      const { boatname, email} = this.state;
          const isLicensed = false;
          // Create a user in your Firebase realtime database
          this.props.firebase
            .license(this.state.id)
            .set({
              boatname,
              email,
              isLicensed,
            })
            .then(() => {
              this.setState({ ...INITIAL_STATE });
              //this.props.history.push(ROUTES.HOME);
            })
            .catch(error => {
              this.setState({ error });
              console.log("cant add user to database", error);
            });
  
      //event.preventDefault();
    };

  
    onChange = event => {
      this.setState({ [event.target.name]: event.target.value });
    };


    id = () => {
        return '_' + Math.random().toString(36).substr(2, 16);
    };

    moneyConvert = (ZARamount, Currency1, Currency2, Currency3) =>{

        axios.get('https://api.openrates.io/latest')
        .then(response=> {
            const euro2zar =  response.data.rates.ZAR;
            const euroAmount1 = response.data.rates[Currency1];
            const euroAmount2 = 1;
            const euroAmount3 = response.data.rates[Currency3];
            const euro = ZARamount/euro2zar;
            const x1 = (euro * euroAmount1).toFixed(2);
            const x2 = (euro * euroAmount2).toFixed(2);
            const x3 = (euro * euroAmount3).toFixed(2);
            this.setState({        
                GBP: x1,
                EUR: x2,
                USD: x3
            });
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .finally(function () {
          // always executed
        });

    }

  
    render() {

    const boxStyle = { 
        maxWidth:'95%',
        width: 'fit-content', 
        background:'rgba(181, 181, 181, 0.07)', 
        borderRadius:'3px', 
        padding:'15px', 
        margin: '25px 5px 25px 5px',
        boxShadow:'0 8px 12px 0 rgba(0, 0, 0, 0.24), 0 6px 20px 0 rgba(0, 0, 0, 0.18)'
    };

    const inputBox = {
        border: '1.5px solid #000000',
        borderRadius: '3px',
        minWidth: '250px',
        padding: '10px',
        background: 'rgba(255, 255, 255, 0.01)',
        marginTop:'10px',
    };

      const {
        boatname,
        email,
        error,
        ZAR,
        GBP,
        EUR,
        USD,
      } = this.state;
  
      const isInvalid =
        email === '' ||
        boatname === '';

      return (

        <div style={{height:'100%', background: 'linear-gradient(158deg, rgb(33, 25, 111) 0%, rgb(59, 185, 175) 100%)'}}>
        <div style={{minHeight:'92vh'}}>
            <CustomNavbar logo={true}></CustomNavbar>
            <Grid container direction="column" justify={'flex-start'} alignItems={'center'} style={{ height:'100%'}}>
                <Grid container direction="column" justify={'center'} alignItems={'center'} style={boxStyle}>
                <img src={logo} style={{maxWidth: '250px', margin:'10px'}}/>
                <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', textAlign:'center'}}>
                    TrueNorth Server requires a once off activation fee.
                </Typography>
                <Grid container direction="row" justify={'center'} alignItems={'center'}style={{marginBottom:'10px'}}>
                    <Grid container direction="row" justify={'center'} alignItems={'flex-start'}>    
                        <Typography variant="subtitle1" style={{marginTop:'2px',padding:'0px', color:'black',marginRight:'4px'}}>
                            ZAR
                        </Typography>               
                        <Typography variant="h3" style={{marginTop:'0px',padding:'0px', color:'black'}}>
                            {ZAR + " |"}
                        </Typography>
                        <div style={{marginTop:'8px', marginLeft:'18px'}}>    
                        <Typography variant="body2" style={{margin:'-3px',padding:'0px', color:'black', fontSize: '0.78em'}}>
                            {"USD "+ USD}
                        </Typography>  
                        <Typography variant="body2" style={{margin:'-3px',padding:'0px', color:'black', fontSize: '0.78em'}}>
                            {"GBP " + GBP}
                        </Typography>  
                        <Typography variant="body2" style={{margin:'-3px',padding:'0px', color:'black', fontSize: '0.78em'}}>
                            {"EUR " + EUR}
                        </Typography>               
                        </div>
                    </Grid>
                </Grid>
                <input
                    name="boatname"
                    value={boatname}
                    onChange={this.onChange}
                    type="text"
                    placeholder="Boat Name"
                    style={inputBox}
                    />
                <input
                    name="email"
                    value={email}
                    onChange={this.onChange}
                    type="email"
                    placeholder="Email Address"
                    style={inputBox}
                />


                <form action="https://www.payfast.co.za/eng/process" method="POST" onSubmit={this.onSubmit}>
                    <input type="hidden" name="merchant_id" value="10922028"/>
                    <input type="hidden" name="merchant_key" value="res04g788ij1q"/>
                    <input type="hidden" name="return_url" value={"https://truenorth-243117.appspot.com/Success?id=" + this.state.id}/>
                    <input type="hidden" name="cancel_url" value={"https://truenorth-243117.appspot.com/Failed"}/>
                    <input type="hidden" name="email_address" value={email}/>
                    <input type="hidden" name="amount" value="2500.00"/>
                    <input type="hidden" name="item_name" value="TrueNorth Server"/>
                    <Button variant="contained" disabled={isInvalid} color="primary" style={{marginTop:'15px'}} type="submit">
                       Pay and Activate
                    </Button>
                    {error && <p>{error.message}</p>}
                </form>
                </Grid>
            </Grid>

            </div>

            <div style={{minHeight:'8vh', boxShadow:'0 0px 12px 0 rgba(0, 0, 0, 0.4), 0 0px 20px 0 rgba(0, 0, 0, 0.4)', backgroundColor:'rgba(54, 153, 162, 0.05)'}}>
              <Grid container direction="row" justify={'center'} alignItems={'center'} style={{height:'8vh'}}>
              <Typography variant="body2" style={{color:'black', textAlign: 'center'}}>
                          Contact us at truenorthsailingsoftware@gmail.com | +27-84-600-6091
              </Typography>
                </Grid>
            </div> 

            
        </div>
      );
    }
  }
  
const SignUpForm = withFirebase(SignUpFormBase);
  
export default Activate
  
export { SignUpForm };
